import React, {Component} from 'react';
import {Switch} from "react-router";
import {Route} from "react-router-dom";
import {compose} from "redux";
import {connect} from 'react-redux';
import {currentEffectiveUserId, searchState} from "../../reducers/ui";
import {Button, Card, List} from "antd/lib/index";
import {clearUserSearch, getUsersQuery} from "../../actions/users";
import ContactSearch from "../Boilerplate/ContactSearch";
import {withLoading} from "../Boilerplate/deferLoaderHoc";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import {withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {addUserToAddressBook, getAddressBookUsers, removeUserFromAddressBook} from "../../actions/addressbook";

const ListDetail = props => {
  const { listUsers, onBack, onAddUser, onDeleteUser } = props;
  return <Card
    title={<h1 className={'nomargins'}>Address Book</h1>}
    extra={<Button.Group>
      <Button onClick={onAddUser} icon={'user-add'}>Add Contact</Button>
    </Button.Group>}
  >
    <h3>User Address Book</h3>
    <List
      dataSource={listUsers}
      renderItem={item => <List.Item actions={[<Button onClick={() => onDeleteUser(item.userid, item.contactuserid)} icon={'user-delete'}>Delete</Button>]}>
        <List.Item.Meta title={`${item.name} - ${item.companyname}`} description={item.emailaddress}/>
      </List.Item>}
    />
  </Card>;
};

const getListDetailProps = props => (({ list, listUsers, onBack, onEdit, onAddUser, onDeleteUser }) =>
  ({ list, listUsers, onBack, onEdit, onAddUser, onDeleteUser }))(props);

const getContactSearchProps = props => (({ searchState, searchResults, onSearchMount, onSearch }) =>
  ({ searchState, searchResults, onSearchMount, onSearch }))(props);

class _ListDetail extends Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount({userId: this.props.userId});
  }

  render() {
    return <Switch>
      <Route exact path="/settings/address-book"
             render={() => <ListDetail {...getListDetailProps(this.props)} />}/>
      <Route path="/settings/address-book/new"
             render={() => <ContactSearch
               {...getContactSearchProps(this.props)}
               disableEmail={true}
               onInvite={this.props.onInvite(this.props.userId)}
               onBack={() => this.props.history.goBack()}
               extras={handleInvite => contact => contact['active'] ? contactCardExtras(contact) :
                 <Button icon={'user-add'} onClick={() => handleInvite(contact)}>Add User</Button>}
             />}/>
    </Switch>
  }
}

const contactCardExtras = contact => <React.Fragment>
  <Button icon={'user-add'} disabled>Added</Button>
</React.Fragment>;

const getHistory = (_, props) => props.history;

const getListUsers = createSelector(
  (state, props) => state.addressbook,
  (listusers) => listusers || {}
);

const listViewStateSelector = createSelector(getListUsers, (listUsers) => ({ listUsers: Object.values(listUsers) }));

const listViewDispatchSelector = createSelector(
  [(dispatch, _) => dispatch, getHistory],
  (dispatch, history) => ({
    onAddUser: () => history.push(`/settings/address-book/new`),
    onDeleteUser: (userId, id) => dispatch(removeUserFromAddressBook(userId, id)),
  })
);

const contactsViewDispatchSelector = createSelector(
  [(dispatch, _) => dispatch, getHistory],
  (dispatch, history) => ({
    onMount: ({ userId }) => {
      dispatch(getAddressBookUsers({ userId }));
    },
    onSearchMount: () => dispatch(clearUserSearch()),
    onNewInvites: () => history.push(`/settings/address-book/new`),
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: userId => contact => dispatch(addUserToAddressBook(userId, contact.contactuserid, () => history.goBack())),
  })
);

const mergedContacts = createSelector(
  getListUsers,
  state => state.ui.userSearchResults,
  (listContacts = {}, searchContacts) => searchContacts.map(id => listContacts[id] ? listContacts[id] : { contactuserid: id })
);

export default compose(
  withBreadcrumbCurried({ title: 'Address Book', path: '/settings/address-book' }),
  connect(
    (state, props) => {
      if (!currentEffectiveUserId(state)) return {loading: true};
      return ({
        userId: currentEffectiveUserId(state),
        searchResults: mergedContacts(state, props),
        searchState: searchState(state, props),
        ...listViewStateSelector(state, props),
      });
    },
    (dispatch, props) => ({
      ...listViewDispatchSelector(dispatch, props),
      ...contactsViewDispatchSelector(dispatch, props),
    }),
  ),
  withLoading
)(_ListDetail);



// WEBPACK FOOTER //
// ./src/components/Settings/AddressBook.js